export type QueueEmployeeType = "ALL" | "REGULAR" | "CONSULTANT" | "SQELABS";
export const QUEUE_EMPLOYEE_TYPE_OPTIONS = [
  { value: "ALL", label: "All" },
  { value: "REGULAR", label: "Regular" },
  { value: "CONSULTANT", label: "Consultant" },
];
export const IT_QUEUE_EMPLOYEE_TYPE_OPTIONS = [
  ...QUEUE_EMPLOYEE_TYPE_OPTIONS,
  { value: "SQELABS", label: "SQE Labs" },
];
export function onboardingQueueParams(stage: "IT" | "HR", employeeType: QueueEmployeeType, page: number, pageSize: number) {
  const params = new URLSearchParams({ stage, page: String(Math.max(0, page - 1)), pageSize: String(pageSize) });
  params.set("employeeType", employeeType === "ALL" ? "" : employeeType);
  return params.toString();
}
